import(/* webpackMode: "eager" */ "/tmp/build_4ec3fd76/src/app/(marketing)/layout.tsx");
